import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import NewReleasesSection from '../components/NewReleasesSection';
import PartnersSection from '../components/PartnersSection';
import LetsGetStartedSection from '../components/LetsGetStartedSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="bg-black min-h-screen container-responsive">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <NewReleasesSection />
        {/* <OriginalsSection /> */}
        <PartnersSection />
        {/* <CTASection /> */}
        <LetsGetStartedSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
